export default "__VITE_ASSET__CipnTmxd__"